import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LocationMultipleLargeInputComponent } from "./location-multiple-large-input.component";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzFormModule } from "ng-zorro-antd/form";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzIconModule } from "ng-zorro-antd/icon";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzSelectModule } from "ng-zorro-antd/select";
import { NzWaveModule } from "ng-zorro-antd/core/wave";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { ExplanationLabelModule } from "../explanation-label/explanation-label.module";
import { LocationsTableListModule } from "../locations-table-list/locations-table-list.module";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import {CountryInputModule} from "../country-input/country-input.module";

@NgModule({
  declarations: [LocationMultipleLargeInputComponent],
  imports: [
    CommonModule,
    ExplanationLabelModule,
    NzButtonModule,
    NzDatePickerModule,
    NzFormModule,
    NzGridModule,
    NzIconModule,
    NzInputModule,
    NzSelectModule,
    NzWaveModule,
    ReactiveFormsModule,
    TranslateModule,
    ExplanationLabelModule,
    LocationsTableListModule,
    NzToolTipModule,
    CountryInputModule,
  ],
  exports: [LocationMultipleLargeInputComponent],
})
export class LocationMultipleLargeInputModule {}
